import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import JobOffer from '../components/JobOffer';
import Navbar from '../components/home/Navbar';

const RecrutementStaff = () => {
  const [jobOffers, setJobOffers] = useState([]);
  const [loading, setLoading] = useState(true); // State to track loading status

  useEffect(() => {
    const fetchJobOffers = async () => {
      setLoading(true); // Set loading to true before fetching data
      try {
        const querySnapshot = await getDocs(collection(db, 'job_staff'));
        const data = querySnapshot.docs.map(doc => {
          const docData = doc.data();
          return {
            id: doc.id,
            title: docData.titre,
            link: docData.lien,
            date: new Date(docData.timestamp.toDate()).toLocaleDateString('fr-FR'), // Format date in French
          };
        });
        setJobOffers(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des offres d'emploi : ", error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    };

    fetchJobOffers();
  }, []);

  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={containerStyle}>
        <h1 style={headingStyle}>Offres de Recrutement Staff</h1>
        {loading ? (
          <div style={loadingStyle}>
            <div style={spinnerStyle}></div>
            <p>Chargement des offres...</p>
          </div>
        ) : (
          <div style={offersContainerStyle}>
            {jobOffers.length > 0 ? (
              jobOffers.map(offer => (
                <JobOffer
                  key={offer.id}
                  title={offer.title}
                  link={offer.link}
                  date={offer.date}
                />
              ))
            ) : (
              <p style={noOffersStyle}>Aucune offre de recrutement disponible pour le moment.</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

// Styles
const pageStyle = {
  backgroundColor: '#f0f4f8', // Light grey-blue background
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const containerStyle = {
  padding: '20px',
  maxWidth: '1200px',
  width: '100%',
  margin: '20px',
  backgroundColor: '#ffffff', // White background for the content area
  borderRadius: '8px', // Rounded corners
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
};

const headingStyle = {
    fontSize: '2.5rem',
    color: '#ffffff', // White text color for contrast
    textAlign: 'center',
    marginBottom: '30px',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    backgroundColor: '#00674b',
    padding: '15px 20px', // Padding around the text
    borderRadius: '8px', // Rounded corners
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', // Subtle shadow for depth
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)', // Slight shadow for better readability
  };

const offersContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const loadingStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '60vh',
};

const spinnerStyle = {
  border: '8px solid #f3f3f3', /* Light grey */
  borderTop: '8px solid #1f77b4', /* Blue color */
  borderRadius: '50%',
  width: '60px',
  height: '60px',
  animation: 'spin 1s linear infinite',
};

// Add the keyframes in a <style> tag or include them in a CSS file
const spinAnimation = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Inject the keyframes into the document head for the animation to work
const style = document.createElement('style');
style.type = 'text/css';
style.innerHTML = spinAnimation;
document.head.appendChild(style);

const noOffersStyle = {
  fontSize: '1.2rem',
  color: '#888888', // Grey color for no offers message
  textAlign: 'center',
  marginTop: '20px',
};

export default RecrutementStaff;
